// extracted by mini-css-extract-plugin
module.exports = {"TagWrapper":"Tag_TagWrapper__bvGEQ"};